(function () {

    'use strict';
    angular.module('angulartics.wgv', [
        'angulartics'
    ])
        .config(config);

    config.$inject = [
        '$analyticsProvider',
        '$windowProvider',
        '$injectorProvider'
    ];

    function config($analyticsProvider, $windowProvider, $injectorProvider) {
        var $window = $windowProvider.$get(),
            $injector = $injectorProvider.$get(),
            $timeout = $injector.get('$timeout'),
            angulartics = $window.angulartics;

        $analyticsProvider.settings.pageTracking.trackRelativePath = true;
        $analyticsProvider.settings.wgv = {
            initialPageLoad: true,
            trackingEnabled: false,
            accountId: null,
            area: ''
        };
        function getPagename(path) {
            return path.replace(/\/$/, '');
        }

        angulartics.waitForVendorApi('_wgvt', 500, function (_wgvt) {
            $analyticsProvider.registerSetUsername(function (properties) {
                if (properties && properties.wgv) {
                    $analyticsProvider.settings.wgv.account = properties.wgv.account;

                    try {
                        if (!_wgvt) {
                            return;
                        }

                        if ($analyticsProvider.settings.wgv.account) {
                            $window._wgvt.setConfig({
                                account: $analyticsProvider.settings.wgv.account
                            });
                        }
                    } catch (e) {
                    }
                }
            });
            $analyticsProvider.registerSetUserProperties(function (properties) {
                properties = properties || {};

                try {
                    if (!_wgvt) {
                        return;
                    }

                    var trackingEnableDisableFn = _wgvt[$analyticsProvider.settings.wgv.trackingEnabled ? 'enableTracking' : 'disableTracking'],
                        config;
                    if (angular.isFunction(trackingEnableDisableFn)) {
                        $window._wgvt[$analyticsProvider.settings.wgv.trackingEnabled ? 'enableTracking' : 'disableTracking']();
                    }

                    angular.forEach(properties.wgv, function (value, prop) {
                        config = {};

                        $analyticsProvider.settings.wgv[prop] = value;

                        if (prop === 'trackingEnabled') {
                            trackingEnableDisableFn = _wgvt[value ? 'enableTracking' : 'disableTracking'];
                            if (angular.isFunction(trackingEnableDisableFn)) {
                                $window._wgvt[value ? 'enableTracking' : 'disableTracking']();
                            }
                        } else {
                            config[prop] = value;
                            $window._wgvt.setConfig(config);
                        }
                    });
                } catch (e) {
                }
            });
            $analyticsProvider.registerPageTrack(function () {
                if ($analyticsProvider.settings.wgv.trackingEnabled !== true) {
                    return;
                }

                var pagename,
                    area,
                    locationHtml5Url = arguments[1],
                    url = arguments[0] || '',
                    path = locationHtml5Url ? locationHtml5Url.$$path : arguments[0];

                if ($window._wgvt && $window._wgvt.trackPage && path) {
                    try {
                        pagename = getPagename(path);
                        area = $analyticsProvider.settings.wgv.area;
                        if ($analyticsProvider.settings.wgv.initialPageLoad && (pagename.indexOf(getPagename($analyticsProvider.settings.etracker.startpage)) > -1 || url.indexOf(getPagename($analyticsProvider.settings.etracker.startpage)) > -1)) {
                            $analyticsProvider.settings.wgv.initialPageLoad = false;
                            return;
                        }

                        $analyticsProvider.settings.wgv.initialPageLoad = false;

                        $window._wgvt.trackPage({
                            action: 'page',
                            area: area,
                            page: pagename,
                            pageNumber: angular.isFunction($analyticsProvider.settings.wgv.getPageIndex) ? $analyticsProvider.settings.wgv.getPageIndex(path) : null
                        });
                    } catch (e) {
                    }
                }
            });
            $analyticsProvider.registerEventTrack(function (action, properties) {
                if ($analyticsProvider.settings.wgv.trackingEnabled !== true) {
                    return;
                }

                if (action === 'button' && properties.disabled) {
                    return;
                }

                properties = properties || {};

                var pagename,
                    area = $analyticsProvider.settings.wgv.area,
                    trackingProvider = angular.isArray(properties.trackingProvider) ? properties.trackingProvider : [properties.trackingProvider],
                    payload = {},
                    options = {};

                $injector.invoke(['$location', function ($location) {
                    pagename = properties.pagename || getPagename($location.$$path);

                    $timeout(function () {
                        if ($window._wgvt && $window._wgvt.trackEvent && action && properties.target && trackingProvider.indexOf('wgv') > -1) {
                            try {
                                if (['input'].indexOf(action) > -1 && angular.isFunction($window._wgvt.trackInput)) {
                                    payload = {
                                        action: action,
                                        area: area,
                                        page: pagename,
                                        name: properties.target,
                                        value: properties.value,
                                        state: properties.state || 'normal'
                                    };

                                    if (properties.force) {
                                        options.force = true;
                                    }

                                    $window._wgvt.trackInput(payload, properties.element, options);
                                } else if (angular.isFunction($window._wgvt.trackEvent)) {
                                    payload = {
                                        action: action,
                                        area: area,
                                        page: pagename,
                                        name: properties.target,
                                        state: properties.state || 'normal'
                                    };

                                    if (['accordion', 'button', 'lead', 'tarifdetails'].indexOf(action) > -1 && properties.value !== undefined) {
                                        payload.value = properties.value;
                                    }

                                    $window._wgvt.trackEvent(payload);
                                }
                            } catch (error) {
                            }
                        }
                    });
                }]);
            });
        });
    }
})();
